/* eslint-disable @typescript-eslint/prefer-interface */
import React, { useMemo,useState } from 'react'
import style from './index.module.scss'
import { PayTypeEnum } from 'types/enum'
import RechargeBox from './RechargeBox'
import RechargeBoxMobile from './RechargeBoxMobile'
import classnames from 'classnames'
import { useMappedState } from 'redux-react-hook'

import iconAlipay from 'assets/img/png/icon_alipay_1@2x.png'
import iconAlipayIntl from 'assets/img/png/icon_alipay_2@2x.png'
import iconPaypal from 'assets/img/png/icon_paypal@2x.png'
import iconWechatpay from 'assets/img/png/icon_wechatpay@2x.png'
import iconUnionPay from 'assets/img/png/icon_unionPay.png'
import { isWidthMobile } from 'utils/utils'

export type payData = {
  text: string
  describe?: string
  type: any
  icon: any
}

export enum RechargeStatus {
  noselect = 'noselect',
  loading = 'loading',
  paying = 'paying',
  success = 'success',
  fail = 'fail',
  selectPayPal = 'selectPayPal',
  querying = 'querying'
}

export interface RechargeProps {
  payDatas: payData[]
  curGoods: any,
  payType: PayTypeEnum | null,
  couponPrice: any,
  useCode: any,
  Complete: any,
  hint: any,
  setuseCode: any,
  setComplete: any,
  sethint: any,
  sethideusecode?: any;
  hideusecode?: any;
  ismodify?: boolean;
  setismodify?: any;
  val?: any;
  setval?: any;
  checkoutCoupon?: any;
  setcheckoutCoupon?: any;
}
//现已关闭微信支付
const payDatas: payData[] = [
  {
    text: '支付宝国际',
    // describe: '海外用户，推荐使用',
    type: PayTypeEnum.alipay_qr_intl,
    icon: iconAlipayIntl,
  },
  {
    text: '支付宝支付',
    type: PayTypeEnum.alipay_qr,
    icon: iconAlipay,
  },
  {
    text: '微信支付',
    type: PayTypeEnum.wx_pub_qr,
    icon: iconWechatpay,
  },
  {
    text: '微信支付',
    type: PayTypeEnum.wx_native_qr,
    icon: iconWechatpay,
  },
  {
    text: 'PayPal支付',
    describe: '支持信用卡付款',
    type: PayTypeEnum.paypal,
    icon: iconPaypal,
  },
  {
    text: '银联支付',
    type: PayTypeEnum.union,
    icon: iconUnionPay,
  },
]

const mobilePayDatas: payData[] = [
  {
    text: '支付宝国际',
    // describe: '海外用户，推荐使用',
    type: PayTypeEnum.alipay_wap_intl,
    icon: iconAlipayIntl,
  },
  {
    text: '支付宝支付',
    type: PayTypeEnum.alipay_wap,
    icon: iconAlipay,
  },
  {
    text: '微信支付',
    type: PayTypeEnum.wx_wap,
    icon: iconWechatpay,
  },
  {
    text: '微信支付',
    type: PayTypeEnum.wx_native_wap,
    icon: iconWechatpay,
  },
  {
    text: 'PayPal支付',
    describe: '支持信用卡付款',
    type: PayTypeEnum.paypal,
    icon: iconPaypal,
  },
  {
    text: '银联支付',
    type: PayTypeEnum.union,
    icon: iconUnionPay,
  },
]

function RechargeCard({ useCode, Complete, hint, setuseCode, setComplete, sethint ,sethideusecode,hideusecode,checkoutCoupon, setcheckoutCoupon}) {
  const [data] = useMappedState((state) => [state.recharge.curGoods]) 
  const [ismodify, setismodify] = useState(false)
  const [val, setval] = useState('')
  // const [checkoutCoupon, setcheckoutCoupon] = useState(true)

  const classes = classnames(style['recharge-card'], {
    [style[`recharge-card-${data.service_days}`]]: !!data.service_days,
  })

  const [curGoods, payType, payments, couponPrice] = useMappedState((state) => [
    state.recharge.curGoods,
    state.recharge.payType,
    state.recharge.payments,
    state.recharge.couponPrice,

  ])

  const curGoodsData = React.useMemo(() => {
    const o = {
      regular_price: curGoods.regular_price,
      present_price: curGoods.present_price,
      discount: curGoods.discount,
    }
    if (payType === PayTypeEnum.paypal) {
      o.regular_price = curGoods.regular_usd_price
      o.present_price = curGoods.present_usd_price
      o.discount = curGoods.usdDiscount
    }
    if (payType === PayTypeEnum.alipay_qr_intl) {
      o.regular_price = curGoods.regular_hkd_price
      o.present_price = curGoods.present_hkd_price
      o.discount = curGoods.hkdDiscount
    }
    return Object.assign({}, curGoods, o)
  }, [curGoods, payType])

  const [payList, mobilePaylist] = useMemo(() => {
    if (payments) {
      if (payments.length > 0) {
        const payList: any[] = []
        const mobilePaylist: any[] = []

        payments.forEach(payment => {
          const pay = payDatas.find(ele => ele.type === payment)
          const mobilePay = mobilePayDatas.find(ele => ele.type === payment)

          if (pay) {
            payList.push(pay)
          }
          if (mobilePay) {
            mobilePaylist.push(mobilePay)
          }
        })

        return [payList, mobilePaylist]
      }
    }


    return [payDatas, mobilePayDatas]
  }, [payments])

  return (
    <div className={classes}>
      <div className={style.title}>支付方式</div>
      {
        isWidthMobile()
          ? <RechargeBoxMobile
            setcheckoutCoupon={setcheckoutCoupon}
            checkoutCoupon={checkoutCoupon} 
            val={val} 
            setval={setval}
            ismodify={ismodify}
            setismodify={setismodify}
            payDatas={mobilePaylist}
            curGoods={curGoods}
            payType={payType}
            couponPrice={couponPrice}
            useCode={useCode}
            Complete={Complete}
            hint={hint}
            setuseCode={setuseCode} setComplete={setComplete} sethint={sethint}
            sethideusecode={sethideusecode}
            hideusecode={hideusecode}
            
          />
          : <RechargeBox
            setcheckoutCoupon={setcheckoutCoupon} 
            checkoutCoupon={checkoutCoupon} 
            val={val}
            setval={setval}
            ismodify={ismodify}
            setismodify={setismodify}
            payDatas={payList}
            curGoods={curGoodsData}
            payType={payType}
            couponPrice={couponPrice}
            useCode={useCode}
            Complete={Complete}
            hint={hint}
            setuseCode={setuseCode} setComplete={setComplete} sethint={sethint}
           
          />
      }
    </div>
  )
}

export default RechargeCard
